import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const ScoreCard = ({ team, score, status, highlight, accent, onClick }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={0.5}
    onClick={onClick}
    sx={{
      position: 'relative',
      width: 96,
      minHeight: 0,
      px: 2,
      py: 2,
      borderRadius: 2,
      overflow: 'hidden',
      color: '#0E1014',
      background: 'linear-gradient(180deg, #F4F4F4 0%, #E1E1E1 100%)',
      border: '1px solid rgba(14,16,20,0.08)',
      boxShadow: '0 16px 32px rgba(0,0,0,0.22)',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': onClick ? {
        transform: 'translateY(-2px)',
        boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
      } : {},
      ...(highlight && accent
        ? {
          '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: 4,
            backgroundColor: accent,
          },
        }
        : {}),
    }}
  >
    <Typography
      sx={{
        color: '#0E1014',
        fontSize: 48,
        fontWeight: 700,
        lineHeight: 1,
        fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
      }}
    >
      {score}
    </Typography>
    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 500,
        color: '#0E1014',
        fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
        textAlign: 'center',
        lineHeight: 1.3,
      }}
    >
      {team}
      {status && (
        <Box component="span" sx={{ display: 'block', fontSize: '0.85em', mt: 0.25, fontWeight: 700 }}>
          {status}
        </Box>
      )}
    </Typography>
  </Stack>
);

ScoreCard.propTypes = {
  team: PropTypes.string.isRequired,
  score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  status: PropTypes.string,
  highlight: PropTypes.bool,
  accent: PropTypes.string,
  onClick: PropTypes.func,
};

export default ScoreCard;

